import React, { useEffect } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { AnnouncementBar } from './components/sections/AnnouncementBar';
import { HeroSection } from './components/sections/HeroSection';
import { ProblemSection } from './components/sections/ProblemSection';
import { SolutionSection } from './components/sections/SolutionSection';
import { TransformationSection } from './components/sections/TransformationSection';
import { BenefitsSection } from './components/sections/BenefitsSection';
import { WhatYouGetSection } from './components/sections/WhatYouGetSection';
import { BonusesSection } from './components/sections/BonusesSection';
import { TestimonialsSection } from './components/sections/TestimonialsSection';
import { OfferSection } from './components/sections/OfferSection';
import { FAQSection } from './components/sections/FAQSection';
import { FinalCTASection } from './components/sections/FinalCTASection';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-rose-50 font-sans text-dark selection:bg-rose-200 selection:text-rose-900" data-id="element-0">
      <AnnouncementBar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <ProblemSection data-id="element-4" />
        <SolutionSection data-id="element-5" />
        <TransformationSection data-id="element-6" />
        <BenefitsSection data-id="element-7" />
        <WhatYouGetSection data-id="element-8" />
        <BonusesSection data-id="element-9" />
        <TestimonialsSection data-id="element-10" />
        <OfferSection data-id="element-11" />
        <FAQSection data-id="element-12" />
        <FinalCTASection data-id="element-13" />
      </main>
      <footer className="bg-dark text-gray-400 py-8 text-center text-sm" data-id="element-14">
        <div className="max-w-7xl mx-auto px-4" data-id="element-15">
          <p data-id="element-16">
            © {new Date().getFullYear()} Empezá y Ganá. Todos los derechos
            reservados.
          </p>
          <p className="mt-2 text-xs opacity-60" data-id="element-17">
            Este sitio no es parte del sitio web de Facebook ni de Facebook Inc.
            Además, este sitio NO está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca registrada de FACEBOOK, Inc.
          </p>
        </div>
      </footer>
    </div>;
}